"use client"

import { Avatar, AvatarFallback, AvatarImage } from "./components/ui/avatar"
import { Button } from "./components/ui/button"
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "./components/ui/card"
import { Input } from "./components/ui/input"
import { Label } from "./components/ui/label"
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./components/ui/select"
import { Separator } from "./components/ui/separator"

const people = [
  {
    name: "김민지",
    email: "minji@example.com",
    avatar: "/avatars/03.png",
  },
  {
    name: "이서연",
    email: "seoyeon@example.com",
    avatar: "/avatars/04.png",
  },
  {
    name: "박지현",
    email: "jihyun@example.com",
    avatar: "/avatars/05.png",
  },
  {
    name: "최준혁",
    email: "junhyuk@example.com",
    avatar: "/avatars/01.png",
  },
]

export function CardsShare() {
  return (
    <Card>
      <CardHeader>
        <CardTitle>문서 공유</CardTitle>
        <CardDescription>링크가 있는 사람은 누구나 이 문서를 볼 수 있습니다.</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="flex items-center gap-2">
          <Label htmlFor="link" className="sr-only">
            링크
          </Label>
          <Input id="link" value="http://example.com/link/to/document" className="h-8" readOnly />
          <Button size="sm" variant="outline" className="shadow-none bg-transparent">
            링크 복사
          </Button>
        </div>
        <Separator className="my-4" />
        <div className="flex flex-col gap-4">
          <div className="text-sm font-medium">접근 권한이 있는 사람</div>
          <div className="grid gap-6">
            {people.map((person) => (
              <div key={person.email} className="flex items-center justify-between gap-4">
                <div className="flex items-center gap-4">
                  <Avatar>
                    <AvatarImage src={person.avatar || "/placeholder.svg"} alt="Image" />
                    <AvatarFallback>{person.name.charAt(0)}</AvatarFallback>
                  </Avatar>
                  <div>
                    <p className="text-sm leading-none font-medium">{person.name}</p>
                    <p className="text-muted-foreground text-sm">{person.email}</p>
                  </div>
                </div>
                <Select defaultValue="edit">
                  <SelectTrigger className="ml-auto pr-2" aria-label="편집" size="sm">
                    <SelectValue placeholder="선택" />
                  </SelectTrigger>
                  <SelectContent align="end">
                    <SelectItem value="edit">편집 가능</SelectItem>
                    <SelectItem value="view">보기 가능</SelectItem>
                  </SelectContent>
                </Select>
              </div>
            ))}
          </div>
        </div>
      </CardContent>
    </Card>
  )
}
